'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRESENTATIONAL_MESSAGE_TYPES = exports.CONVERSATIONAL_MESSAGE_TYPES = exports.AUTOMATED_CHAT_MESSAGE_TYPES = undefined;

var _immutable = require('immutable');

var _messageTypes = require('./messageTypes');

var _messageTypes2 = require('../../common-message-format/constants/messageTypes');

var AUTOMATED_CHAT_MESSAGE_TYPES = exports.AUTOMATED_CHAT_MESSAGE_TYPES = (0, _immutable.List)([_messageTypes.EMAIL_CAPTURE_PROMPT, _messageTypes.EMAIL_CAPTURE_RESPONSE, _messageTypes.OFFICE_HOURS, _messageTypes.TYPICAL_RESPONSE_TIME, _messageTypes.CHAT_RICH_TEMPLATE]);

var CONVERSATIONAL_MESSAGE_TYPES = exports.CONVERSATIONAL_MESSAGE_TYPES = (0, _immutable.List)([_messageTypes.INITIAL_MESSAGE, _messageTypes.CHAT_MESSAGE, _messageTypes.OFFLINE, _messageTypes.EMAIL_MESSAGE, _messageTypes.THREAD_COMMENT, _messageTypes2.COMMON_MESSAGE]).concat(AUTOMATED_CHAT_MESSAGE_TYPES);

var PRESENTATIONAL_MESSAGE_TYPES = exports.PRESENTATIONAL_MESSAGE_TYPES = (0, _immutable.List)([_messageTypes.ASSIGNMENT, _messageTypes.ASSIGNMENT_V2, _messageTypes.FILTERED_CHANGE]).concat(CONVERSATIONAL_MESSAGE_TYPES);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/constants/messageTypeGroups.js
// module id = 684
// module chunks = 2 3